import axiosClient from './axiosClient';

export interface LoginPayload {
    username: string;
    password: string;
}

export const authApi = {
    login: (data: LoginPayload) => {
        // fastapi OAuth2 needs to be sent as x-www-form-urlencoded
        const formData = new URLSearchParams();
        formData.append('username', data.username);
        formData.append('password', data.password);

        return axiosClient.post('/auth/login', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    },

    getMe: () => {
        return axiosClient.get('/users/me');
    },
    
    loginAsChild: (childId: string) => {
        return axiosClient.post(`/auth/login-as-child/${childId}`);
    },

    verifyAccountInfo: (params: { token?: string; email?: string; otp_code?: string } | string) => {
        const queryParams = typeof params === 'string' ? { token: params } : params;
        return axiosClient.get('/auth/verify-account-info', { params: queryParams });
    },

    setPasswordVerified: (data: { token?: string; email?: string; otp_code?: string; new_password: string }) => {
        return axiosClient.post('/auth/set-password-verified', data);
    },

    requestOtp: (data: { target: string; token_type?: string }) => {
        return axiosClient.post('/auth/request-otp', data);
    },

    verifyOtp: (data: { target: string; otp_code: string; token_type?: string }) => {
        return axiosClient.post('/auth/verify-otp', data);
    },

    resetPassword: (data: { target: string; otp_code?: string; token?: string; new_password: string }) => {
        return axiosClient.post('/auth/reset-password', data);
    }
};
